module.exports = __webpack_public_path__ + "img/SM.0690f962.svg";